import { styled } from '~/styled'

export const DrawerHeader = styled('div', {
  base: ['p-4', 'w-full', 'min-h-16', 'border-b', 'border-b-(--base-3)']
})
